export default {
  default: [
    {
      path: "/account",
      name: "account",
      component: () => import("./views/AccountView.vue")
    }
  ]
};
